import RepositoryService from 'src/services/repository'

const resource = 'company'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  patch: async ({ logo, ...data }) => {
    const response = await RepositoryService.crud.patch(resource, {
      ...data,
      ...(logo ? { logo } : {}),
    }, { isFormData: true })
    return response?.data ?? response
  },
  getUserList: companyId => RepositoryService.crud.getList(`${resource}/${companyId}/user`),
  getTokensDemandList: companyId => RepositoryService.crud.getList(`${resource}/${companyId}/demandsHistory`),
  getTokensDemand: (companyId, demandId) => RepositoryService.crud.get(`${resource}/${companyId}/demandsHistory`, demandId),
  getTokensHistory: companyId => RepositoryService.crud.getList(`${resource}/${companyId}/tokensHistory`),
  patchTokensDemand: (companyId, demand) => RepositoryService.crud.patch(`${resource}/${companyId}/demandsHistory`, demand),
  sendAction: (companyId, name, payload, options) => RepositoryService.crud.post(`${resource}/${companyId}/${name}`, payload, options),
  restore: idList => RepositoryService.crud.post(`${resource}/restore`, { idList }),
  user: {
    getList: (companyId, ...args) => RepositoryService.crud.getList(`${resource}/${companyId}/user`, ...args),
    get: (companyId, ...args) => RepositoryService.crud.get(`${resource}/${companyId}/user`, ...args),
    patch: (companyId, ...args) => RepositoryService.crud.patch(`${resource}/${companyId}/user`, ...args),
    post: (companyId, ...args) => RepositoryService.crud.post(`${resource}/${companyId}/user`, ...args),
    delete: (companyId, ...args) => RepositoryService.crud.delete(`${resource}/${companyId}/user`, ...args),
    restore: (companyId, idList) => RepositoryService.crud.post(`${resource}/${companyId}/user/restore`, { idList }),
  },
}
